import { render } from "./AboutMainPage.vue?vue&type=template&id=99a0587c&scoped=true"
import script from "./AboutMainPage.vue?vue&type=script&lang=js"
export * from "./AboutMainPage.vue?vue&type=script&lang=js"

import "./AboutMainPage.vue?vue&type=style&index=0&id=99a0587c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99a0587c"]])

export default __exports__